





























































































































































































































































import { Link, MediaItem, Tag, Work } from "@/api/models";
import { OptionItem, SiteState, SubmissionState } from "@/store/types";
import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { VueEditor } from "vue2-editor";
import { Action, State } from "vuex-class";
import deepEqual from "deep-equal";
import { saveWork } from "../api/methods";
import { emptyString, notEmptyString } from "../api/validators";
import TagField from "./widgets/TagField.vue";
import MediaForm from "./widgets/MediaForm.vue";
import TextForm from "./widgets/TextForm.vue";
import LinkField from "./widgets/LinkField.vue";
import DisplayOptionSet from "./widgets/DisplayOptionSet.vue";
import HelpWidget from "./widgets/HelpWidget.vue";
import sortableElement from "../api/sortable";
import { customToolbar, textChange } from "../settings/wysiwyg";
import { bus } from "@/main";
import { compareModTs, plainTextData } from "@/api/helpers";
import { hasErrorInSection } from "@/api/dom";
import { extractWorkObject } from "@/api/extract-entries";
import { extractAllTags, extractTagItems, highlightTags } from "@/api/expand-tags";
import { captureHashTags, enableContainerDescription, enableContainerTags, enableTextItem, requireSponsorUrl } from "@/.config";

@Component({
  components: {
    TagField,
    MediaForm,
    LinkField,
    DisplayOptionSet,
    VueEditor,
    HelpWidget,
    TextForm,
  },
  filters: {},
})
export default class WorkForm extends Vue {
  @Prop({ default: "" }) workId: string;
  @Prop({ default: () => [] }) tagList: Array<Tag>;
  @State("site") site: SiteState;
  @State("submission") submission: SubmissionState;
  @Action("assignSubmission", { namespace: "submission" })
  assignSubmission: Function;

  work: Work = new Work();

  titleError = false;

  saving = false;

  msg = "";

  error = false;

  changeDetected = false;

  changeChecked = false;

  autoSaveInterval = -1;

  sortMode = false;

  syncing = false;

  currentRemoveMediaId = "";

  promptTitle = false;

  uploading = false;

  detecting = false;

  created() {
    this.disableEvents();
    this.sync();
    bus.$on("media-saved", ({ workId }) => {
      if (workId === this.workId) {
        this.work.mediaItems = this.submission.works[this.workIndex].mediaItems;
        if (this.submission.submitted) {
          setTimeout(() => {
            this.saveDetails(false, false, false, true);
          }, 2000);
        }
        /* setTimeout(() => {
          this.uploading = false;
        }, 1500); */
        this.uploading = false;
      }
    });
    bus.$on("media-updated", ({ workId }) => {
      if (workId === this.workId) {
        this.detectChange();
      }
    });
    bus.$on("work-themes-updated", ({ workId }) => {
      if (workId === this.workId) {
        if (this.workIndex < this.submission.works.length) {
          this.work.themes = this.submission.works[this.workIndex].themes;
        }
      }
    });
    bus.$on("remove-media", ({ workId, mediaItemId, index }) => {
      this.handleRemoveMedia(workId, mediaItemId, index);
    });
    bus.$on("update-work-link", ({ link, index, workId }) => {
      if (workId === this.workId) {
        if (index < this.work.links.length) {
          this.work.links[index] = link;
        } else {
          this.work.links.push(link);
        }
      }
    });
    bus.$on("delete-work-link", ({ index, workId }) => {
      if (workId === this.workId) {
        if (index < this.work.links.length) {
          this.work.links.splice(index, 1);
        }
      }
    });
    bus.$on("save-work", ({ workId }) => {
      // reset saving state to force a new save if workId is correctly matched
      this.saving = false;
      this.detectChange();
      if (workId === this.workId) {
        this.saveDetails(false, true, true, true);
      }
    });
    this.autoSaveInterval = setInterval(() => {
      const { path } = this.$route;
      if (path.includes("work")) {
        this.detectChange();
      }
    }, 15 * 1000);
    bus.$on("toggle-sort", (mode: boolean) => {
      this.sortMode = mode;
    });
    bus.$on("escape", () => {
      //this.sortMode = false;
      this.uploading = false;
    });
    bus.$on("add-work-title-error", () => {
      this.titleError = true;
      this.error = true;
      this.msg = this.site.label("work__add_title");
    });
    bus.$on("cancel-upload", () => {
      this.uploading = false;
    });
  }

  mounted() {
    setTimeout(this.initSortable, 750);
  }

  beforeDestroy() {
    this.disableEvents();
    this.$off("show-message");
  }

  disableEvents() {
    bus.$off([
      "media-updated",
      "media-saved",
      "work-themes-updated",
      "remove-media",
      "save-work",
      "update-work-link",
      "delete-work-link",
      "add-work-title-error",
      "cancel-upload",
    ]);
    /* bus.$off("media-saved");
    bus.$off("work-themes-updated");
    bus.$off("remove-media");
    bus.$off("save-work");
    bus.$off("update-work-link");
    bus.$off("delete-work-link");
    bus.$off("add-work-title-error");
    bus.$off("cancel-upload");
    bus.$off("check-for-changes"); */
/*  
    bus.$off("work-saved");
    bus.$off("save");
    bus.$off("save-locked");
    bus.$off("upload-ref"); */
  }

  unmounted() {
    if (this.autoSaveInterval >= 0) {
      clearInterval(this.autoSaveInterval);
    }
    bus.$off("show-message");
  }

  initSortable() {
    const element = document.getElementById(this.mediaContainerId);
    if (element instanceof HTMLElement) {
      const hasOnAttr = element.hasAttribute("data-sort");
      if (!hasOnAttr) {
        element.setAttribute("data-sort", "on");
        sortableElement(element, ".handle", (e) => {
          const { newIndex, oldIndex, target } = e;
          if (newIndex < target.childNodes.length) {
            this.movePdfsToBottom();
            if (
              oldIndex >= 0 &&
              oldIndex < this.work.mediaItems.length &&
              newIndex >= 0 &&
              newIndex < this.work.mediaItems.length &&
              newIndex !== oldIndex
            ) {
              const refItem = this.work.mediaItems.splice(oldIndex, 1)[0];
              this.work.mediaItems.splice(newIndex, 0, refItem);
              if (!this.saving) {
                this.saveMediaItems();
              }
            }
          }
        });
      }
    } else {
      setTimeout(this.initSortable, 500);
    }
  }

  disableSort() {
    this.sortMode = false;
  }

  enableSort() {
    this.sortMode = true;
  }

  toggleSort() {
    this.sortMode = !this.sortMode;
  }

  get sortToggleType() {
    return this.sortMode ? "is-success" : "is-normal";
  }

  get editToggleType() {
    return this.sortMode ? "is-normal" : "is-primary";
  }

  get explicitLabel() {
    const key = 'work__explicit_label';
    const lbl = this.site.snippets.find(sn => sn.key === key);
    if (lbl instanceof Object) {
      return lbl.value;
    } else {
      return this.site.label("work__explicit");
    }
  }

  movePdfsToBottom() {
    this.work.mediaItems = [...this.mainMediaItems, ...this.docItems];
  }

  get mediaContainerId() {
    return ["media-item-form", this.workId].join("-");
  }

  get isNew() {
    return emptyString(this.work._id, 12);
  }

  get textEditorId() {
    return ["text-editor", "work", this.workId].join("-");
  }

  get toolbar() {
    return customToolbar;
  }

  get mainMediaItems() {
    return this.work.mainMediaItems;
  }

  get hasMainMediaItems() {
    return this.mainMediaItems.length > 0 && !this.syncing;
  }

  get hasPdf() {
    return this.work.docItems.length > 0 && !this.syncing;
  }

  get docItems() {
    return this.work.docItems;
  }

  get docIndex() {
    return this.work.mediaItems.findIndex((mi) => mi.type === "document");
  }

  get mediaItemClasses() {
    return this.sortMode ? ["sort-mode"] : ["static-mode"];
  }

  get showMediaLimitHintForPDF() {
    return this.subHasMedia && this.hasPdf;
  }

  get maxDescriptionCharCount() {
    return 3000;
  }
  get textCounter() {
    const data = plainTextData(this.work.description);
    const wordsRef = "word count";
    return (
      [data.chars, this.maxDescriptionCharCount].join(" / ") +
      ` (${wordsRef} ${data.words})`
    );
  }

  get excludedSlugs() {
    return this.groupMode ? this.site.definedThemeSlugs : [];
  }

  get wrapperClasses() {
    const cls = [];
    if (this.isNew) {
      cls.push("new-work");
    }
    if (notEmptyString(this.work.title)) {
      cls.push("has-title");
    } else {
      cls.push("untitled");
    }
    return cls;
  }

  get requireSponsorUrl() {
    return requireSponsorUrl;
  }

  get showTags() {
    return enableContainerTags;
  }

  get showDescription() {
    return enableContainerDescription;
  }

  matchdocIndex(mediaId = "") {
    const refIndex = this.work.mediaItems.findIndex((mi) => mi._id == mediaId);
    return refIndex < 0 ? this.work.mediaItems.length - 1 : refIndex;
  }

  get containerIdString() {
    const num = this.workIndex + 1;
    if (num > 0) {
      const parts = [["Container", num].join(": ")];
      if (notEmptyString(this.work.title)) {
        parts.push(this.work.title);
      }
      return parts.join(" － ");
    } else {
      return "New: unsaved";
    }
  }

  get titleClasses() {
    const cls = ["title-field", "required"];
    if (this.titleError) {
      cls.push("error");
    }
    return cls;
  }

  get titleType() {
    return this.titleError
      ? "is-danger"
      : notEmptyString(this.work.title)
      ? "is-success"
      : "is-normal";
  }

  get displayOptionRows(): Array<OptionItem> {
    return [];
  }

  get maxMediaItems(): number {
    const max = this.site.settings.get("max_files_per_work");
    return max > 0 ? max : 5;
  }

  get maxMediaItemsPerSubmission(): number {
    const max = this.site.settings.get("max_mediaitems_per_submission");
    return max > 0 ? max : 25;
  }

  get numMediaInSub() {
    return this.submission.works
      .map((w) => w.mediaItems.length)
      .reduce((a, b) => a + b, 0);
  }

  get mediaLimitHint(): string {
    return this.site
      .label("media_item_limit_hint")
      .replace("%num", this.numMediaInSub)
      .replace("%max", this.maxMediaItemsPerSubmission);
  }

  get subHasMedia() {
    return this.numMediaInSub > 0 && !this.isNew;
  }

  get uploadLimitReachedMessage(): string {
    return this.site
      .label("media_item_max_limit_reached")
      .replace("%max", this.maxMediaItemsPerSubmission);
  }

  get mayAddMedia() {
    return this.workId.length > 8;
  }

  get mayAddMoreMediaItems() {
    return (
      this.mayAddMedia &&
      this.work.mediaItems.length < this.maxMediaItems &&
      this.numMediaInSub < this.maxMediaItemsPerSubmission
    );
  }

  get maxTags() {
    const max = this.site.settings.get("max_tags_per_work");
    return typeof max === "number" ? max : 4;
  }

  get saveContainerLabel() {
    const innerKey = this.workId.length > 8 ? "save" : "presave";
    return this.site.label(["work_", innerKey, "label"].join("_"));
  }

  sync() {
    this.syncing = true;
    if (notEmptyString(this.workId, 12)) {
      this.work = this.submission.works.find(
        (work) => work._id === this.workId
      );
      if (captureHashTags && notEmptyString(this.work.description, 8)) {
        this.work.description = extractAllTags(this.work.description);
      }
    } else {
      this.work = new Work();
    }
    if (!this.isNew) {
      this.$ls.set(this.refKey, extractWorkObject(this.work));
    }
    setTimeout(() => {
      if (this.work.links.length < 1) {
        this.addLink();
      }
      this.syncing = false;
      
    }, 500);
    setTimeout(this.initSortable, 500);
  }

  get hasMediaItems() {
    let valid = false;
    if (this.work.mediaItems instanceof Array && !this.syncing) {
      valid = this.work.mediaItems.length > 0;
    }
    return valid;
  }

  get refKey() {
    return ["work", this.work._id].join("-");
  }

  hasChanged() {
    if (!this.isNew) {
      const workObj = this.$ls.get(this.refKey);
      if (workObj instanceof Object) {
        const newObj = extractWorkObject(this.work);
        const isSame = deepEqual(workObj, newObj);
        if (!isSame) {
          this.$ls.set(this.refKey, newObj);
        }
        return !isSame;
      }
    }
    return true;
  }

  updateDisplayOptions(displayOpts = null, workId = "") {
    if (
      !this.syncing &&
      workId === this.workId &&
      displayOpts instanceof Object &&
      displayOpts instanceof Object
    ) {
      this.work.displayOptions = displayOpts;
      if (
        this.workIndex >= 0 &&
        this.workIndex < this.submission.works.length
      ) {
        this.submission.works[this.workIndex].displayOptions = displayOpts;
      }
      this.detectChange();
    }
  }

  promptRemove() {
    this.titleError = false;
    this.remove(false);
  }

  remove(confirm = false) {
    const num = this.work.mediaItems.length;
    const plural = num > 1 ? "s" : "";
    const mediaMsg = this.hasMediaItems
      ? `\nThis container has ${num} media item${plural}`
      : "";
    const title = `‟${this.work.title}〞`;
    const question = confirm
      ? `Confirm?`
      : `Do you want to delete this container? ${title}`;
    const message = confirm
      ? [question].join("\n")
      : [question, mediaMsg].join("\n");
    this.$buefy.dialog.confirm({
      message,
      type: "is-danger",
      hasIcon: confirm,
      icon: "trash-can-outline",
      onConfirm: () => this.handleDelete(num, confirm),
    });
  }

  handleDelete(num = 0, confirm = false) {
    if (num < 1 || confirm) {
      this.deleteItem();
    } else {
      this.remove(true);
    }
  }

  deleteItem() {
    const workIndex = this.submission.works.findIndex(
      (w) => w._id === this.workId
    );
    if (workIndex >= 0 && workIndex < this.submission.works.length) {
      this.submission.works.splice(workIndex, 1);
      this.assignSubmission(this.submission);

      const prevIndex = workIndex - 1;
      const w = prevIndex < 0 ? null : this.submission.works[prevIndex];
      const next = prevIndex < 0 ? "preview" : `work-${w._id}-${prevIndex}`;
      bus.$emit("save", { msg: "Container deleted", delay: 2000 });
      setTimeout(() => {
        bus.$emit("goto", next, true);
      }, 1000);
    } else if (this.isNew) {
      const lastIndex = this.submission.works.length - 1;
      const w = lastIndex < 0 ? null : this.submission.works[lastIndex];
      const next = lastIndex < 0 ? "overview" : `work-${w._id}-${lastIndex}`;
      bus.$emit("goto", next, true);
    }
  }

  addMedia(mode = "media") {
    if (this.workIndex < 0) {
      if (notEmptyString(this.work.title)) {
        this.saveDetails();
        setTimeout(() => {
          bus.$emit("upload-ref", { refKey: "_new", type: "work", mode });
        }, 2000);
      } else {
        this.titleError = true;
      }
    } else {
      bus.$emit("upload-ref", { refKey: "_new", type: "work", mode });
    }
    this.sortMode = false;
    this.uploading = true;
  }

  addPdf() {
    this.addMedia("pdf");
  }

  handleRemoveMedia(workId = '', mediaItemId = '', index = -1) {
    if (
      workId === this.workId &&
      !this.saving &&
      mediaItemId !== this.currentRemoveMediaId
    ) {
      this.currentRemoveMediaId = mediaItemId;
      const mediaIndex = this.work.mediaItems.findIndex(
        (mi) => mi._id === mediaItemId
      );
      if (mediaIndex >= 0 && mediaIndex >= index && index >= 0) {
        const mi = this.work.mediaItems[mediaIndex];
        const isDoc = mi.type === "document";
        const refIndex = isDoc
          ? this.docItems.findIndex((mi) => mi._id === mediaItemId)
          : this.mainMediaItems.findIndex((mi) => mi._id === mediaItemId);
        const total = isDoc
          ? this.docItems.length
          : this.mainMediaItems.length;
        const num = refIndex + 1;
        if (num > 0 && total > 0) {
          const numDialogBoxes = document.querySelectorAll(".dialog.modal")
            .length;
          if (numDialogBoxes < 1) {
            const extra = `  (${num}/${total})`;
            this.$buefy.dialog.confirm({
              message: `Delete this ${mi.type}: ${mi.name}?${extra}`,
              type: "is-danger",
              onConfirm: () => this.deleteMedia(mediaIndex),
              onCancel: () => {
                this.currentRemoveMediaId = "";
              },
            });
          }
        }
      }
    }
  }

  deleteMedia(index: number) {
    if (index >= 0 && index < this.work.mediaItems.length) {
      this.saving = false;
      const mId = this.work.mediaItems[index]._id;
      if (mId === this.currentRemoveMediaId) {
        this.$delete(this.work.mediaItems, index);
        this.saveMediaItems(true);
        this.currentRemoveMediaId = "";
      }
    }
    return false;
  }

  get workIndex() {
    return this.submission.works.findIndex((work) => work._id === this.workId);
  }

  hasNoEmptyLinks(): boolean {
    return this.work.links.filter(lk => emptyString(lk.title)).length < 1;
  }

  addLink() {
    if (this.hasNoEmptyLinks() && !hasErrorInSection()) {
      this.work.links.push(new Link());
    }
  }

  saveMediaItems(skipToast = false) {
    if (this.workIndex < this.submission.works.length && this.workIndex >= 0) {
      this.submission.works[this.workIndex].mediaItems = this.work.mediaItems;
      this.saveDetails(skipToast !== true, true, true);
    }
  }

  htmlChange(delta, source) {
    this.work.description = textChange(delta, source, this.work.description);
  }

  updateTags() {
    if (captureHashTags) {
      const textTags = extractTagItems(this.work.description);
      if (textTags.length > 0) {
        textTags.forEach((item: Tag) => {
          const exists = this.work.themes.some(tg => tg.slug === item.slug);
          if (!exists) {
            this.work.themes.push(item);
          }
        });
        setTimeout(() => {
          bus.$emit('update-tags', {name: "work.themes", id: this.workId});
        }, 125);
      }
    }
  }

  validate() {
    return notEmptyString(this.work.title, 1);
  }

  save() {
    bus.$emit("saving-work", { workId: this.workId });
    this.msg = "";
    this.error = false;
    if (this.validate()) {
      setTimeout(() => {
        if (
          this.workIndex >= 0 &&
          this.workIndex < this.submission.works.length
        ) {
          this.work.mediaItems = this.submission.works[
            this.workIndex
          ].mediaItems.filter((mi) => notEmptyString(mi.filename, 5));
          this.movePdfsToBottom();
        }
        this.saveDetails();
      }, 250);
    } else {
      this.msg = this.site.label("work__add_title");
      this.error = true;
      this.titleError = !notEmptyString(this.work.title);
      bus.$emit("save-locked", true);
    }
  }

  get groupMode() {
    return ['group','project','projects'].includes(this.site.mode);
  }

  get textItemEnabled() {
    return enableTextItem;
  }

  showField(fieldName = ''): boolean {
    return !this.hideFromGroup(fieldName);
  }

  hideFromGroup(fieldName = ''): boolean {
    if (this.groupMode) {
      const sFields = this.site.settings.get('disabled_group_container_fields')
      const suppressFields = sFields instanceof Array ? sFields : ['medium', 'size', 'links'];
      return suppressFields.includes(fieldName);
    } else {
      return false;
    }
  }

  saveDetailsConditional() {
    if (notEmptyString(this.work.title) && this.workId.length < 12) {
      this.msg = "";
      this.error = false;
      this.saveDetails(false);
    } else if (this.isNew) {
      this.error = true;
    }
  }

  saveDetails(showToast = true, storeLocal = true, saveMediaItems = true, skipAlert = false) {
    this.work.description = highlightTags(this.work.description);
    const ts = compareModTs() ? this.submission.modifiedTs : 0;
    // count empty alt fields when saving after uploading items
    const emptyAltNums = this.uploading? [] : this.work.mediaItems.map((item, index) => {
      return  {
        num: index + 1,
        item
      }
    }).filter(row => row.item.needsRequiredFields).map(row => row.num);
    const hasEmptyAlt = emptyAltNums.length > 0 && hasErrorInSection();
    if (hasEmptyAlt && (storeLocal || !skipAlert)) {
      const nums = emptyAltNums.map(num => num.toString()).join(", ");
      const pl = emptyAltNums.length > 1 ? 's' : '';
      bus.$emit('show-message', {
        workId: this.workId,
        index: emptyAltNums[0] - 1,
        msg: `Please add alt text in the highlighted field${pl} (media items ${nums})`
      });
    }
    const proceed = (!this.saving && this.changeDetected) || saveMediaItems;
    if (!hasEmptyAlt && proceed) {
      this.changeDetected = false;
      this.saving = true;
      bus.$emit("active", true);
      //const workIds = this.submission.works.map(w => w._id);
      saveWork(this.submission._id, this.work, ts).then((data) => {
        const { valid, work, modifiedAt } = data;
        const isNew = this.isNew === true; // temp copy of reactive property
        if (valid && work instanceof Object) {
          if (modifiedAt) {
            this.submission.modifiedAt = new Date(modifiedAt);
          }
          const editedWork = new Work(work);
          const { _id } = editedWork;
          const currIndex = this.submission.works.findIndex(
            (w) => w._id === _id
          );
          if (currIndex >= 0) {
            this.submission.works[currIndex] = editedWork;
            if (captureHashTags) {
              this.work.description = extractAllTags(editedWork.description);
            }
          } else if (isNew) {
            const currIndex = this.submission.works.findIndex(
              (w) => w._id === _id
            );
            if (currIndex < 0) {
              this.submission.works.push(editedWork);
            }
          }
          if (this.work.links.length < 1) {
            this.addLink();
          }
          if (storeLocal) {
            this.submission.works = this.submission.works.filter((w) =>
              notEmptyString(w._id, 12)
            );
            this.assignSubmission(this.submission);
            this.$ls.set("submission", this.submission);
            if (showToast) {
              const index =
                this.workIndex >= 0
                  ? this.workIndex
                  : this.submission.works.length - 1;
              bus.$emit("work-saved", {
                title: editedWork.title,
                index,
                isNew,
              });
            }
          }
          setTimeout(() => {
            this.saving = false;
          }, 500);
        }
      });
      setTimeout(() => {
        this.saving = false;
      }, 5000);
    }
  }

  get actionClasses() {
    return this.changeDetected && notEmptyString(this.work.title)
      ? ["changed"]
      : this.changeChecked
      ? ["not-changed"]
      : [];
  }


  get deleteContainerLabel() {
    return this.site.labels.get('delete_container_label');
  }

  addTextItem() {
    const textItem = new MediaItem({
      _id: "_new",
      filename: "text.txt",
      type: "text",
      source: "db",
      mime: "text/html",
      title: "",
    });
    if (this.workIndex < this.submission.works.length) {
      const hasNewTextItem = this.work.mediaItems.some((mi) =>
        mi._id.startsWith("_new")
      );
      if (!hasNewTextItem) {
        this.submission.works[this.workIndex].mediaItems.push(textItem);
        this.work.mediaItems = this.submission.works[this.workIndex].mediaItems;
      }
    }
  }

  detectChange() {
    if (!this.detecting) {
      this.changeChecked = true;
      this.detecting = true;
      if (this.hasChanged()) {
        this.changeDetected = true;
      }
      setTimeout(() => {
        this.detecting = false;
      }, 125);
    }
  }

  checkForChanges() {
    if (!this.changeDetected) {
      this.detectChange();
    }
    if (!hasErrorInSection() && !this.titleError) {
      bus.$emit("unlock", true);
    }
  }

  registerChange(e) {
    const { target } = e;
    if (
      ["input", "textarea", "select", "option", "button"].includes(
        target.tagName.toLowerCase()
      ) ||
      target.classList.contains("ql-editor")
    ) {
      this.checkForChanges();
      bus.$emit("active", true);
    }
    if (!hasErrorInSection() && !this.titleError) {
      bus.$emit("unlock", true);
    }
    bus.$emit("form-click", e);
  }

  @Watch("mediaItems")
  changeMediaItems() {
    setTimeout(this.initSortable, 750);
  }

  @Watch("workId")
  changeWorkId() {
    setTimeout(this.sync, 125);
    this.sortMode = false;
    this.titleError = false;
    this.error = false;
  }

  @Watch("work.title")
  changeWorkTitle() {
    if (notEmptyString(this.work.title)) {
      this.titleError = false;
    }
  }

  @Watch("work", { deep: true })
  changeWork() {
    this.detectChange();
  }

  @Watch("changeDetected")
  changChangeDetected(newVal) {
    if (newVal === true) {
      bus.$emit('unlock', true);
    }
  }
}
